import React from 'react';
import { PDFViewer } from '@react-pdf/renderer';

import Typography from '@material-ui/core/Typography'

import BookingFormPDF from './BookingFormPDF';

const BookingFormPreview = ({ intermediary, referral, request, courtCase, quote, notes, court }) => {
    const digest = { intermediary, referral, request, courtCase, quote, notes, court };

    return (
        <div>
            <Typography variant="h6" color="initial">Booking Form Preview</Typography>
            <PDFViewer width='100%' height='800px'>
                <BookingFormPDF digest={digest} />
            </PDFViewer>
        </div>
    );
};

export default BookingFormPreview;